<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="$t('SeaExport.DoorAddress')"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      @closed="handleClose"
      @update:visible="val => $emit('update:visible', val)"
    >
      <div>
        <!-- 查询条件 -->
        <el-form label-width="60px" label-position="left" style="width: 100%;margin-bottom: 5px">
          <el-row :gutter="10">
            <el-col :span="5">
              <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
                <el-input v-model="site.companyName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Partners.doorName')">
                <el-input v-model="filter.name" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Payment.contactPerson')">
                <el-input v-model="filter.contact" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('SeaExport.Tel')">
                <el-input v-model="filter.phone" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Partners.detailAddress')">
                <el-input v-model="filter.address" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="!showArea" :gutter="10">
            <el-col :span="5">
              <el-form-item :label="$t('CargoMsg.Cargo_CityP')">
                <el-input v-model="filter.city" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$t('Payment.remarks')">
                <el-input v-model="filter.remarks" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="operation-buttons">
                <el-button type="primary" @click="filter.pageNum=1;handleSearch()">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                <el-button @click="resetFilter">{{ $t('common.btn.reset') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="showArea" :gutter="10">
            <el-col :span="5">
              <el-form-item :label="$t('Payment.remarks')">
                <el-input v-model="filter.remarks" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form inline label-position="left">
                <cargo-area
                  ref="filterArea"
                  no="filterArea"
                  filterable
                  :allow-create="false"
                  country="CN"
                  :province.sync="filter.province"
                  :city.sync="filter.cityNew"
                  :district.sync="filter.county"
                  :town.sync="filter.town"
                  :district-label-name="$t('CargoMsg.Cargo_CountyDistrict')"
                  :town-label-name="$t('CargoMsg.Cargo_TownStreet')"
                  :town-style="{marginRight: 0}"
                  placeholder=" "
                  :label-width="'60'"
                  :show-town="true"
                  :select-width="95"
                />
              </el-form>
            </el-col>
          </el-row>
          <el-row v-if="showArea" :gutter="10">
            <el-col :span="21">
              <el-form-item class="operation-buttons">
                <el-button type="primary" @click="filter.pageNum=1;handleSearch()">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                <el-button @click="resetFilter">{{ $t('common.btn.reset') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <div>
                <el-button
                  no="new"
                  :disabled="!isEdit"
                  type="primary"
                  @click="showEditDialog(true)"
                >{{ $t('common.btn.new') }}</el-button>
                <el-button
                  no="edit"
                  :disabled="!isEdit"
                  type="primary"
                  @click="showEditDialog(false)"
                >{{ $t('common.btn.edit') }}</el-button>
                <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
              </div>
            </div>
          </div>
          <div class="grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="girdParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;min-height:300px"
            />
          </div>
          <!-- 分页 -->
          <div class="pagination-container">
            <cargo-pagination
              v-show="total>0"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              :total="total"
              @pagination="handleSearch"
            />
            <el-button class="close-btn" @click="handleCancel">{{ $t('common.btn.close') }}</el-button>
          </div>
        </div>
        <!-- 编辑弹窗 -->
        <el-dialog
          v-el-drag-dialog
          :visible.sync="editDialog.visible"
          :title="editDialog.title"
          width="400px"
          :close-on-click-modal="false"
          append-to-body
        >
          <div class="app-main-inner-row" style="padding-bottom: 10px;">
            <el-form label-width="100px" label-position="left">
              <el-form-item :label="$t('Partners.doorName')">
                <el-input v-model="editDialog.form.name" no="name" />
              </el-form-item>
              <el-form-item :label="$t('Payment.contactPerson')">
                <el-input v-model="editDialog.form.contact" no="contact" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Tel')">
                <el-input v-model="editDialog.form.phone" no="phone" />
              </el-form-item>
              <el-form-item :label="$t('Partners.detailAddress')">
                <el-input v-model="editDialog.form.address" no="address" />
              </el-form-item>
              <el-form-item :label="$t('Payment.remarks')">
                <el-input v-model="editDialog.form.remarks" no="remarks" />
              </el-form-item>
              <el-form-item v-show="!showArea" :label="$t('CargoMsg.Cargo_CityP')">
                <cargo-advance-select
                  no="city"
                  :cache="false"
                  filterable
                  :default-value="editDialog.form.city"
                  :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                  :tag-value="'code'"
                  :placeholder="' '"
                  :static-options="locationList"
                  @parentCallBack="p=>{editDialog.form.city=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.ZIP')">
                <el-input v-model="editDialog.form.zipCode" no="zipCode" />
              </el-form-item>
              <cargo-area
                v-show="showArea"
                ref="area"
                no="area"
                :country.sync="editDialog.form.country"
                :province.sync="editDialog.form.province"
                :city.sync="editDialog.form.cityNew"
                :district.sync="editDialog.form.county"
                :town.sync="editDialog.form.town"
                :district-label-name="$t('CargoMsg.Cargo_CountyDistrict')"
                :town-label-name="$t('CargoMsg.Cargo_TownStreet')"
                :label-width="'100'"
                :select-width="280"
                :show-town="true"
                style="display: inline-block"
              />
            </el-form>
          </div>
          <span slot="footer">
            <el-button
              v-if="showArea"
              no="aiRecognitionRegion"
              type="primary"
              size="mini"
              style="height: 32px; margin: 4px 10px 0 0;"
              @click="openAiRegionRecognition"
            >{{ $t('CargoMsg.CargoMsg_AIAddressRecognition') }}</el-button>
            <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
            <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
          </span>
        </el-dialog>
      </div>
    </el-dialog>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { delSite, getSiteList, saveDoorSite } from '@/api/partner/site'
import { getLocationList } from '@/api/location'
import { getLoading } from '@/utils/utilBaseElement'
import $store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'DoorPointInformation',
  components: {
    CargoAiRecognitionDialog, cargoArea, cargoAdvanceSelect
  },
  props: {
    showArea: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    site: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      SystemConstants,
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        visible: false
      },
      selectTypeNames: TYPE_NAMES,
      total: 0,
      filter: {
        companyUuid: '',
        name: '',
        contact: '',
        phone: '',
        address: '',
        city: '',
        country: 'CN',
        province: '',
        cityNew: '',
        county: '',
        town: '',
        remarks: '',
        pageNum: 1,
        pageSize: 10
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      rowData: [],
      locationList: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          country: 'CN',
          province: '',
          cityNew: '',
          county: '',
          town: '',
          companyUuid: '',
          zipCode: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum(),
      selectedNode: null,
      deletedSiteKeys: []
    }
  },
  computed: {
    columnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('Partners.doorName'),
          field: 'name',
          width: 150
        }, {
          headerName: this.$t('Payment.contactPerson'),
          field: 'contact',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'phone',
          width: 150
        }, {
          headerName: this.$t('Partners.detailAddress'),
          field: 'address',
          width: 200
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }
      ]
      if (this.showArea) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_Province'),
          field: 'province',
          width: 200
        })
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_city'),
          field: 'cityNewStr',
          width: 200
        })
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_CountyDistrict'),
          field: 'countyStr',
          width: 200
        })
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_TownStreet'),
          field: 'townStr',
          width: 200
        })
      } else {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_CityP'),
          field: 'city',
          width: 150,
          valueFormatter: (params) => {
            let name = ''
            if (this.locationList) {
              const data = this.locationList.find(p => p.code === params.value)
              if (data) {
                name = this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
              }
            }
            return name
          }
        })
      }
      return columnDefs
    },
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    'editDialog.visible': {
      handler(newValue, oldValue) {
        if (newValue) {
          this.clear()
        }
      }
    },
    visible: {
      handler(val) {
        if (val) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    openAiRegionRecognition() {
      this.aiRecognitionDialog.multimodal = false
      this.aiRecognitionDialog.promptKey = SystemConstants.REGION_PROMPT_KEY.code
      this.aiRecognitionDialog.placeholder = this.$t('SeaExport.RecognitionTextTip')
      this.aiRecognitionDialog.callBack = (jsonStr) => this.aiRecognitionRegionPostHandler(jsonStr)
      this.aiRecognitionDialog.visible = true
    },

    async aiRecognitionRegionPostHandler(jsonStr) {
      const parsed = this.safeJsonParse(jsonStr)
      const region = Array.isArray(parsed) ? parsed[0] : parsed
      if (!region) {
        return
      }

      const provinceName = region.province
      const cityName = region.city
      const districtName = region.district
      const streetName = region.street
      const detailAddress = region.detail || region.detailAddress || region.addressDetail || region.address
      const name = region.name
      if (name) {
        this.editDialog.form.contact = String(name).trim()
      }

      const phone = region.phone
      if (phone) {
        this.editDialog.form.phone = String(phone).trim()
      }

      if (detailAddress) {
        this.editDialog.form.address = String(detailAddress).trim()
      }

      if (provinceName || cityName || districtName || streetName) {
        await this.applyRegionByNames({ provinceName, cityName, districtName, streetName })
      }
    },

    safeJsonParse(input) {
      if (!input) {
        return null
      }
      if (typeof input !== 'string') {
        return input
      }
      try {
        return JSON.parse(input)
      } catch (e) {
        return null
      }
    },

    normalizeCnDivisionName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(
          /(\u7701|\u5e02|\u533a|\u53bf|\u81ea\u6cbb\u5dde|\u81ea\u6cbb\u53bf|\u81ea\u6cbb\u533a|\u7279\u522b\u884c\u653f\u533a)$/g,
          ''
        )
    },

    normalizeCnTownName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/(街道|镇|乡|苏木|民族乡)$/g, '')
    },

    findDivisionByName(divisionList, name) {
      const normalized = this.normalizeCnDivisionName(name)
      if (!normalized) {
        return null
      }

      const exact = (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name) === normalized)
      if (exact) {
        return exact
      }

      return (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name).includes(normalized))
    },

    findTownByName(townList, name) {
      const normalized = this.normalizeCnTownName(name)
      if (!normalized) {
        return null
      }

      const exact = (townList || []).find((t) => this.normalizeCnTownName(t?.name) === normalized)
      if (exact) {
        return exact
      }

      return (townList || []).find((t) => this.normalizeCnTownName(t?.name).includes(normalized))
    },

    async ensureAreaReady() {
      const area = this.$refs.area
      if (!area) {
        return null
      }
      if (Array.isArray(area.provinceList) && area.provinceList.length > 0) {
        return area
      }

      if (typeof area.init === 'function') {
        await area.init('CN')
      }
      return area
    },

    async applyRegionByNames({ provinceName, cityName, districtName, streetName }) {
      const area = await this.ensureAreaReady()
      if (!area) {
        return
      }

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      const waitUntil = async(fn, timeoutMs = 2000, intervalMs = 50) => {
        const deadline = Date.now() + timeoutMs
        while (Date.now() < deadline) {
          if (fn()) {
            return true
          }
          await sleep(intervalMs)
        }
        return false
      }

      const province = this.findDivisionByName(area.provinceList, provinceName)
      if (!province?.code) {
        return
      }
      this.editDialog.form.province = province.code
      await area.getDivisionByParentCode(province.code, 2)
      await waitUntil(() => Array.isArray(area.cityList) && area.cityList.length > 0)

      const city = this.findDivisionByName(area.cityList, cityName)
      if (!city?.code) {
        return
      }
      this.editDialog.form.cityNew = city.code
      await area.getDivisionByParentCode(city.code, 3)
      await waitUntil(() => Array.isArray(area.districtList) && area.districtList.length > 0)

      const district = this.findDivisionByName(area.districtList, districtName)
      if (!district?.code) {
        return
      }
      this.editDialog.form.county = district.code

      if (streetName) {
        await area.getDivisionByParentCode(district.code, 4)
        await waitUntil(() => Array.isArray(area.townList) && area.townList.length > 0)
        const town = this.findTownByName(area.townList, streetName)
        if (town?.uuid) {
          this.editDialog.form.town = town.uuid
        }
      }
    },

    clear() {
      if (this.$refs.area) {
        this.$refs.area.clearCity()
        this.$refs.area.clearDistrict()
        this.$refs.area.clearTown()
      }
    },
    init() {
      this.filter.companyUuid = this.site.companyUuid
      this.handleSearch()
      this.queryLocation()
    },
    handleClose() {
      this.rowData = []
      this.$emit('update:visible', false)
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
    handleSearch() {
      const loading = getLoading()
      this.filter.branchId = $store.getters.currentOfficeId
      getSiteList(this.filter).then(res => {
        this.total = Number(res.data.total)
        for (const item of res.data.list) {
          item.seq = this.autoIncrementNum.getNextNum()
        }
        this.rowData = res.data.list
      }).finally(() => loading.close())
    },
    queryLocation() {
      // 获取城市列表
      getLocationList({ pageSize: 10000 }).then(res => {
        this.locationList = res.data.list
      })
    },
    resetFilter() {
      this.filter = {
        ...this.filter,
        name: '',
        contact: '',
        phone: '',
        address: '',
        city: '',
        country: 'CN',
        province: '',
        cityNew: '',
        county: '',
        town: '',
        remarks: '',
        pageNum: 1
      }
      if (this.$refs.filterArea) {
        this.$refs.filterArea.clearCity()
        this.$refs.filterArea.clearDistrict()
        this.$refs.filterArea.clearTown()
      }
      this.handleSearch()
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          country: 'CN',
          province: '',
          cityNew: '',
          county: '',
          town: '',
          companyUuid: this.filter.companyUuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...this.selectedRow }
        this.editDialog.form.country = 'CN' // 固定国内
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    saveSub() {
      const self = this
      const form = self.editDialog.form
      for (const key in form) {
        if (typeof form[key] === 'string') { // 确保字段值是字符串
          form[key] = form[key].trim() // 去掉前后空格
        }
      }
      if (!this.showArea && !form.name && !form.address && !form.contact && !form.phone && !form.city) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseInputOneDoorInfoAtLeast'))
        return
      }
      if (this.showArea && !form.name && !form.address && !form.contact && !form.phone &&
        !form.province && !form.cityNew && !form.county && !form.town) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseInputOneDoorInfoAtLeast'))
        return
      }
      form.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      saveDoorSite(form).then(res => {
        if (!res.data) {
          self.$message.error(self.$t('CargoMsg.Cargo_ExistDoorSite'))
        } else {
          this.handleSearch()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
      setTimeout(() => {
        this.$emit('loadSites')
      }, 1000)
    },
    remove() {
      const self = this
      const row = self.selectedRow
      if (!this.selectedRow) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        delSite(row.uuid).then(() => {
          self.$message.success(self.$t('common.tips.deleteSuccess'))
          this.handleSearch()
        }).catch(() => {
        }).finally(() => loading.close())
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
.el-form {
  .el-form-item {
    margin-bottom: 10px;

    .el-form-item__label {
      text-align: right;
      padding-right: 8px;
      line-height: 32px;
    }

    :deep(.el-input) {
      width: 180px;
    }

    &.operation-buttons {
      text-align: right;
      margin-left: auto;
      :deep(.el-input) {
        width: auto;
      }
      .el-button + .el-button {
        margin-left: 10px;
      }
    }
  }
}

.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;

  .close-btn {
    margin-left: 15px;
  }
}
</style>
